import { combineReducers } from 'redux'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { Platform } from 'react-native'
import AsyncStorage from '@react-native-async-storage/async-storage'
import loginReducer from './login/loginReducer'
import userReducer from './user/userReducer'
import initReducer from './initReducer/initReducer'
import forgotPasswordReducer from './forgotPassword/forgotPasswordReducer'
import toastReducer from './notifications/notificationReducer'
import dashboardReducer from './dashboard/dashboardReducer'
import preferredLanesReducer from './preferredLane/preferredLanesReducer'
import loadDetailsReducer from './loadDetails/loadDetailsReducer'
import locationsReducer from './locations/locationsReducer'
import globalThemeReducer from '../theming/globalThemeReducer'
import myLoadsReducer from './loads/myAvaliableReducer'
import allLoadsReducer from './loads/allAvaliableReducer'
import profileReducer from './profile/userInformationReducer'
import carrierInformationReducer from './profile/carrierInformationReducer'
import myOffersReducer from './offers/myOffersReducer'
import historyOffersReducer from './offers/historyReducer'
import assignedOrdersReducer from './orders/assignedReducer'
import readyOrdersReducer from './orders/readyReducer'
import recurringReducer from './tractors/recurringReducer'
import myDriversReducer from './tractors/myDriversReducer'
import invoiceReducer from './payments/invoiceReducer'
import paymentReducer from './payments/paymentReducer'
import paymentsConnectReducer from './paymentsConnect/paymentsConnectReducer'
import loginTypes from './login/loginTypes'
import faqsReducer from './faqs/faqsReducer'

const rootReducer = combineReducers({
  initReducer,
  userReducer,
  loginReducer,
  forgotPasswordReducer,
  toastReducer,
  dashboardReducer,
  preferredLanesReducer,
  locationsReducer,
  globalThemeReducer,
  myLoadsReducer,
  allLoadsReducer,
  myOffersReducer,
  loadDetailsReducer,
  profileReducer,
  assignedOrdersReducer,
  readyOrdersReducer,
  historyOffersReducer,
  carrierInformationReducer,
  recurringReducer,
  myDriversReducer,
  invoiceReducer,
  paymentReducer,
  paymentsConnectReducer,
  faqsReducer
})

const persistConfig = {
  key: 'Eah#95/Icad!2020',
  storage: Platform.OS === 'web' ? storage : AsyncStorage,
  whitelist: ['globalThemeReducer', 'initReducer']
}

const resetEnhancer = (_rootReducer) => (state, action) => {
  if (action.type !== loginTypes.LOGOUT) return _rootReducer(state, action)

  const newState = _rootReducer({ globalThemeReducer: state.globalThemeReducer }, action)
  newState.router = state.router
  return newState
}

export default persistReducer(persistConfig, resetEnhancer(rootReducer))
